// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: true,
  apiUrl: 'https://api-vendor.aclarian.com/api/',
  baseUrl: 'https://santarosabocc-vendor.aclarian.com',
  appName: 'Santa Rosa BOCC | VendorV2',
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pub858c615cc400e8856bab79d89ae1403d',
  datadogApplicationId: 'd4337394-06c3-4b27-9361-86595099cebe',
  datadogService: 'invoicing_santarosabocc_prod',
  ApiKey: 'N7#P2Z@kLqM8%T4Yv',
  env: 'Prod',
  version: packageInfo.version,
};
